import { render, staticRenderFns } from "./FavLocationsMain.vue?vue&type=template&id=98e24120"
import script from "./FavLocationsMain.vue?vue&type=script&lang=ts"
export * from "./FavLocationsMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports